import { Component, getAssetPath, h } from "@stencil/core";

@Component({
	tag: "sitenna-logo",
	styleUrl: "sitenna-logo.css",
	shadow: true,
})
export class SitennaLogo {
	render() {
		return (
			<a href="https://sitenna.com">
				<span>Powered By&nbsp;</span>
				<img
					alt="sitenna logo"
					src={getAssetPath("assets/logo-white-text.svg")}
				/>
			</a>
		);
	}
}
